module.exports = __webpack_public_path__ + "static/media/timer_icon.7997b6f4.png";